import React, {useState} from 'react';
import './index.scss';
import { getProviderNameById, getUserNameById } from '../../../services/restaurant.js';
import IconButton from "../IconButton/IconButton.jsx";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {createAction} from "../../../utils/sagaHelper.js";
import {SET_ORDER_DELIVERED_BY} from "../../../store/reducers/order/order-actions.js";
import {Tooltip} from "antd";
import CouriersShiftPopup from "../../containers/CouriersShiftPopupContainer/index.js";
import {
    EXTERNAL_COURIER_PROVIDER,
    getExternalCourierProviderNameByProvider,
    POPUP_ITEM_TYPE,
    USER_FILTER_ROLES,
} from '../../../utils/enums.js';

const EditCourierDelivery = ({order}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [isConfirmOpen, setConfirmOpen] = useState(false);

    const name = getUserNameById(order.deliveryBy);

    const handleApplyCourierDelivery = (userId) => {
        if(userId && order.deliveryBy !== userId) {
            dispatch(createAction(SET_ORDER_DELIVERED_BY, {
                orderId: order.id,
                courierId: userId,
                newView: true,
            })).then(() => {
                handleOnEditDelivery(false);
            })
        }
    }

    const handleOnEditDelivery = (value) => {
        setConfirmOpen(value);
    }

    const handleOnClose = () => {
        setConfirmOpen(false);
    }

    const shortName = name.length > 20 ? `${name.slice(0, 20)?.trim()}...` : name;

    return (
        name
            ? (
                <div className={'courierNameEdit'}>
                    <>
                        <IconButton isIcon={true}
                                    iconName={"orderEdit"}
                                    tooltipText={t("dashboard.orders.EDIT_ORDER_DELIVERY")}
                                    onClick={() => handleOnEditDelivery(true)}
                        />
                        <Tooltip title={name}>
                            <span>{shortName}</span>
                        </Tooltip>
                    </>
                    <CouriersShiftPopup
                        itemType={POPUP_ITEM_TYPE.shiftsFilterItem}
                        roles={[USER_FILTER_ROLES.courier]}
                        onUserClick={data => handleApplyCourierDelivery(data.userId)}
                        isOpen={isConfirmOpen}
                        onClose={handleOnClose}
                    />
                </div>
            )
            : order.deliveryProvider === EXTERNAL_COURIER_PROVIDER.delivApp
                ? getProviderNameById(order.deliveryProviderId)
                : getExternalCourierProviderNameByProvider(order.deliveryProvider) || null
    )
}

export default EditCourierDelivery;